var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8289 6.61821V7.72125H22.0323V6.61821C22.0323 2.96827 19.0676 0 15.422 0H14.3203V2.20607H15.422C17.8524 2.20607 19.8289 4.18492 19.8289 6.61821Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60967 19.855V18.752H4.40625V19.855C4.40625 23.5049 7.37095 26.4732 11.0165 26.4732H12.1182V24.2671H11.0165C8.58614 24.2671 6.60967 22.2883 6.60967 19.855Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91539 0H2.20342C0.986031 0 0 0.987217 0 2.20607V14.3395C0 15.5583 0.986031 16.5455 2.20342 16.5455H9.91539C11.1328 16.5455 12.1188 15.5583 12.1188 14.3395V2.20607C12.1188 0.987217 11.1328 0 9.91539 0ZM9.91539 13.2364H2.20342V3.30911H9.91539V13.2364Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2357 9.92773H16.5237C15.3063 9.92773 14.3203 10.915 14.3203 12.1338V24.2672C14.3203 25.4861 15.3063 26.4733 16.5237 26.4733H24.2357C25.4531 26.4733 26.4391 25.4861 26.4391 24.2672V12.1338C26.4391 10.915 25.4531 9.92773 24.2357 9.92773ZM24.2357 23.1642H16.5237V13.2368H24.2357V23.1642Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.d40ab924ca37ec3d24ca660b078831da.svg";
export { ForwardRef as ReactComponent };